import {Model} from 'vue-mc'
import Vue from "vue";

export default class invoiceModel extends Model {

	// Default attributes
	defaults() {
		return {
			publicApiURL: Vue.prototype.$publicApiURL,
			jobID: 0
		}
	}

	options() {
		return {
			methods: {
				getInvoice: 'GET'
			}
		}
	}

	routes() {
		return {
			getInvoice: 'job/{jobID}/all_slip'
		}
	}

	setJobID(jobID) {
		this.jobID = jobID;
		let route = this.publicApiURL + this.getRoute('getInvoice');
		let params = this.getRouteParameters();

		return this.getURL(route, params);
	}
}



// WEBPACK FOOTER //
// ./src/models/invoiceModel.js